import * as tslib_1 from "tslib";
import { Exclude } from 'class-transformer';
import { UpdatedResultDto } from '../../common/updated-result-dto';
export class GLJournalAttachmentRawDto extends UpdatedResultDto {
}
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", String)
], GLJournalAttachmentRawDto.prototype, "downloadUrl", void 0);
